import {
  COWS_FETCH_REQUEST,
  COWS_FETCH_SUCCESS,
  COWS_FETCH_FAIL,
  COWS_SET_SORT,
  COWS_SELECT_COW,
  COWS_VIDEO_PLAY_STOP,
  COWS_SET_PAGE,
  COWS_SET_PAGE_SIZE
} from './constants';
import {
  COW_FILTERS_RESET_ALL,
  COW_FILTERS_SET_MIN_PRICE,
  COW_FILTERS_SET_MAX_PRICE,
  COW_FILTERS_SET_MIN_AGE,
  COW_FILTERS_SET_MAX_AGE,
  COW_FILTERS_SET_ATTRIBUTES,
  COW_FILTERS_SET_BREEDS,
  COW_FILTERS_SET_TYPE,
  COW_FILTERS_SET_VISIBLE,
  COW_FILTERS_SET_FAVOURITED,
  COW_FILTERS_SET_INTERESTED,
  COW_FILTERS_SET_MIN_SCORE,
  COW_FILTERS_SET_MAX_SCORE,
  COW_FILTERS_SET_SEARCH
} from '../cowFilters/constants';
import {
  USER_REGISTER_INTEREST,
  USER_MARK_FAVOURITE
} from '../user/constants';
import { createSelector } from 'reselect';
import { monthsFromDate } from '../util/datesAndAges';
import addDocumentsToScores from './util/addDocumentsToScores';
import { getGradeFromScore } from '../admin/scoreDefinitions/util';

const initialState = {
  fetching: false,
  cows: {},
  sortAttribute: 'Recommended',
  selectedCowId: null,
  videoPlaying: false,
  doubleClickPrevention: null,
  page: 1,
  pageSize: window.innerHeight > 700 ? 12 : 8
};

export const calcScores = cow => {
  cow.production.qualityIndex = Object.values(cow.production).map(
    attribute => attribute.score
  ).reduce((a, b) => a + b);
  cow.eating.qualityIndex = Object.values(cow.eating).map(
    attribute => attribute.score
  ).reduce((a, b) => a + b);
  cow.environment.qualityIndex = Object.values(cow.environment).map(
    attribute => attribute.score
  ).reduce((a, b) => a + b);
  cow.beefQualityIndex = cow.environment.qualityIndex +
    cow.eating.qualityIndex + cow.production.qualityIndex;
};

export const addVideoData = cow => {
  if (cow.orgVideo && !cow.orgVideo.timestamps) {
    cow.orgVideo.timestamps = {
      'views': [],
      'straplines': [
        { 'timestamp': 2, 'duration': 3, 'label': 'grass fed' },
        { 'timestamp': 6, 'duration': 3, 'label': 'home bred' },
        { 'timestamp': 10, 'duration': 3, 'label': 'high health and welfare' },
        { 'timestamp': 14, 'duration': 2, 'label': 'sustainable' },
        { 'timestamp': 17, 'duration': 3, 'label': 'nutritionally rich' }
      ]
    };
  }
};

// const video = {
//   mp4: 'https://media.beefbook.com/web/Warson_Bedrich_U155_1080.mp4',
//   dash: 'https://media.beefbook.com/dash/master.mpd',
//   hls: 'https://media.beefbook.com/hls/master.m3u8',
//   /* eslint-disable max-len */
//   poster: 'https://media.beefbook.com/Warson_Filming_30_4_19/Warson_Bedrich_U155_30-4-19.jpg',
//   date: '06/03/2019',
//   timestamps: {
//     views: [
//       { timestamp: 1.6, label: 'front', duration: 2 },
//       { timestamp: 4.3, label: 'fertility', duration: 2 },
//       { timestamp: 7, label: 'side', duration: 2 },
//       { timestamp: 13, label: 'structure', duration: 2 }
//     ],
//     straplines: [
//       { timestamp: 1.5, label: 'shows docility with the farmer', duration: 3 },
//       { timestamp: 6, label: 'good locomotion', duration: 4 },
//       { timestamp: 11, label: 'high docility', duration: 3 },
//       { timestamp: 13.3, label: 'great structure', duration: 4 }
//     ]
//   }
// };

const cows = (state = initialState, action) => {
  switch (action.type) {
    case COWS_FETCH_REQUEST:
      return { ...state, fetching: true };
    case COWS_FETCH_SUCCESS: {
      const cows = {};
      action.cows.forEach(cow => {
        const newCow = { ...cow };
        calcScores(newCow);
        addDocumentsToScores(newCow, action.scoreDefinitions);
        newCow.age = monthsFromDate(cow.dob);
        addVideoData(newCow);
        newCow.grade = getGradeFromScore(newCow.beefQualityIndex);
        cows[cow.id] = newCow;
      });
      return { ...state, cows, fetching: false };
    }
    case COWS_FETCH_FAIL:
      return { ...state, fetching: false };
    case COWS_SET_SORT:
      return { ...state, sortAttribute: action.sortAttribute, page: 1 };
    case COWS_SELECT_COW:
      return { ...state, selectedCowId: action.id };
    case COWS_VIDEO_PLAY_STOP: {
      const doubleClickPrevention = Date.now();
      const videoPlaying = (Date.now() - state.doubleClickPrevention) > 600
        ? action.playing : state.videoPlaying;
      return { ...state, videoPlaying, doubleClickPrevention };
    }
    case USER_REGISTER_INTEREST: {
      const cows = JSON.parse(JSON.stringify(state.cows));
      cows[action.cow.id].interestRegistered = true;
      return { ...state, cows };
    }
    case USER_MARK_FAVOURITE: {
      const cows = JSON.parse(JSON.stringify(state.cows));
      if (action.isFavourite) {
        cows[action.cow.id].favourite = true;
      } else {
        delete cows[action.cow.id].favourite;
      }
      return { ...state, cows };
    }
    case COWS_SET_PAGE: {
      return { ...state, page: action.page };
    }
    case COWS_SET_PAGE_SIZE: {
      return { ...state, pageSize: action.pageSize };
    }
    case COW_FILTERS_RESET_ALL:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_MIN_PRICE:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_MAX_PRICE:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_MIN_AGE:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_MAX_AGE:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_ATTRIBUTES:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_BREEDS:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_TYPE:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_VISIBLE:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_FAVOURITED:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_INTERESTED:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_MIN_SCORE:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_MAX_SCORE:
      return { ...state, page: 1 };
    case COW_FILTERS_SET_SEARCH:
      return { ...state, page: 1 };
  }
  return state;
};

export default cows;

const cowsObject = state => state.cow.cows;
const sort = state => state.cow.sortAttribute;
const cowId = state => state.cow.selectedCowId;
const videoPlaying = state => state.cow.videoPlaying;
const fetching = state => state.cow.fetching;
const page = state => state.cow.page;
const pageSize = state => state.cow.pageSize;

export const isFetching = createSelector(
  fetching, fetching => fetching
);

export const getCows = createSelector(
  cowsObject, cows => Object.values(cows)
  // cowsObject, cows => {
  //   const result = Object.values(cows);
  //   result.forEach(cow => console.log(`${cow.name}: ${cow.type}`));
  //   console.log(`----COWS LENGTH: ${result.length}-------`);
  //   return Object.values(cows);
  // }
);
export const getCowCount = createSelector(
  getCows, cows => cows.length
);
export const getSortAttribute = createSelector(
  sort, sort => sort
);
export const getVideoPlaying = createSelector(
  videoPlaying, playing => playing
);
export const getSelectedCow = createSelector(
  [cowId, cowsObject], (cowId, cowsObject) => {
    try {
      return cowsObject[cowId];
    } catch (error) {
      return null;
    }
  }
);
export const hasSelectedFavourite = createSelector(
  getCows, cows => {
    for (let i = 0; i < cows.length; i++) {
      if (cows[i].favourite) return true;
    }
    return false;
  }
);
export const hasRegisteredInterest = createSelector(
  getCows, cows => {
    for (let i = 0; i < cows.length; i++) {
      if (cows[i].interestRegistered) return true;
    }
    return false;
  }
);
export const getCowPage = createSelector(
  page, page => page
);
export const getCowPageSize = createSelector(
  pageSize, pageSize => pageSize
);
